import type { ReactNode } from 'react';

import { Card as MuiCard, styled } from '@mui/material';

const StyledCard = styled(MuiCard)`
  padding: 54px;
`;

type Props = {
  children: ReactNode;
  className?: string;
};

export const Card = ({ children, className }: Readonly<Props>) => {
  return (
    <StyledCard variant="outlined" className={className}>
      {children}
    </StyledCard>
  );
};
